export interface Review {
  id: string;
  communityId: string;
  author: string;
  avatar: string;
  rating: number;
  date: string;
  content: string;
  helpful: number;
  verified: boolean;
}

export const reviews: Review[] = [
  {
    id: 'r1',
    communityId: '1',
    author: 'Marcus Chen',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3001&orientation=squarish',
    rating: 5,
    date: '2026-03-20',
    content: 'Absolutely the best AI community I\'ve found on Telegram. The daily paper discussions are incredibly insightful, and the admins do a great job keeping conversations on-topic. Highly recommend for anyone serious about ML.',
    helpful: 42,
    verified: true,
  },
  {
    id: 'r2',
    communityId: '1',
    author: 'Sophia Müller',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20european%20female%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3002&orientation=squarish',
    rating: 4,
    date: '2026-02-14',
    content: 'Great community with lots of knowledgeable members. Sometimes the volume of messages can be overwhelming, but the signal-to-noise ratio is much better than most groups. The job board is a hidden gem.',
    helpful: 28,
    verified: true,
  },
  {
    id: 'r3',
    communityId: '1',
    author: 'Raj Patel',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20indian%20male%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3003&orientation=squarish',
    rating: 5,
    date: '2026-01-08',
    content: 'Found my current job through this community\'s job board. The weekly AMA sessions with researchers are world-class. This is the real deal for AI professionals.',
    helpful: 61,
    verified: false,
  },
  {
    id: 'r4',
    communityId: '2',
    author: 'Alex Rivera',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20latin%20male%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3004&orientation=squarish',
    rating: 5,
    date: '2026-03-15',
    content: 'The signals here are genuinely profitable. I\'ve been trading crypto for 3 years and this community has the most accurate technical analysis I\'ve seen. The admins are responsive and transparent.',
    helpful: 89,
    verified: true,
  },
  {
    id: 'r5',
    communityId: '2',
    author: 'Emma Thompson',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20british%20female%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3005&orientation=squarish',
    rating: 4,
    date: '2026-02-28',
    content: 'Very active community with real-time updates. The altcoin alpha channel is worth joining alone. Docking one star because it can get noisy during bull runs, but that\'s expected.',
    helpful: 34,
    verified: true,
  },
  {
    id: 'r6',
    communityId: '3',
    author: 'Jordan Kim',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20korean%20young%20person%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3006&orientation=squarish',
    rating: 5,
    date: '2026-03-10',
    content: 'Found my co-developer here for my Steam game. The monthly game jams are super fun and the feedback culture is constructive and encouraging. Best indie dev community by far.',
    helpful: 19,
    verified: true,
  },
  {
    id: 'r7',
    communityId: '4',
    author: 'Dr. Lena Fischer',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20german%20female%20doctor%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3007&orientation=squarish',
    rating: 4,
    date: '2026-01-22',
    content: 'As a physician, I appreciate the evidence-based approach here. The discussions on digital health tools are nuanced and the community respects scientific consensus. A rare find.',
    helpful: 47,
    verified: true,
  },
  {
    id: 'r8',
    communityId: '5',
    author: 'Yuki Tanaka',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20japanese%20female%20artist%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3008&orientation=squarish',
    rating: 5,
    date: '2026-03-05',
    content: 'The weekly art challenges pushed me to improve so much. The community is incredibly supportive — no gatekeeping, just genuine passion for art. I\'ve made real friends here.',
    helpful: 23,
    verified: false,
  },
  {
    id: 'r9',
    communityId: '6',
    author: 'Dmitri Volkov',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20russian%20male%20developer%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3009&orientation=squarish',
    rating: 5,
    date: '2026-02-18',
    content: 'The Solidity audit reviews alone are worth joining. Found two critical bugs in my smart contract thanks to community feedback before mainnet launch. Saved me from a potential disaster.',
    helpful: 76,
    verified: true,
  },
  {
    id: 'r10',
    communityId: '7',
    author: 'Priya Sharma',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20indian%20female%20entrepreneur%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3010&orientation=squarish',
    rating: 5,
    date: '2026-03-01',
    content: 'Met my co-founder here. The quality of founders in this group is exceptional — everyone is building something real. The investor intro program is legitimate and has led to actual funding for members.',
    helpful: 55,
    verified: true,
  },
  {
    id: 'r11',
    communityId: '8',
    author: 'Wei Zhang',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20chinese%20male%20tech%20professional%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3011&orientation=squarish',
    rating: 4,
    date: '2026-02-10',
    content: 'Best resource for APAC tech news. The bilingual content is a huge plus. Covers markets that Western tech media completely ignores. Essential for anyone doing business in Asia.',
    helpful: 38,
    verified: true,
  },
  {
    id: 'r12',
    communityId: '9',
    author: 'Pierre Dubois',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20french%20male%20photographer%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3012&orientation=squarish',
    rating: 4,
    date: '2026-01-30',
    content: 'The critique sessions are honest but kind. My photography improved dramatically in 3 months. The gear marketplace saved me hundreds on used equipment. Solid community overall.',
    helpful: 16,
    verified: false,
  },
  {
    id: 'r13',
    communityId: '10',
    author: 'Tyler Brooks',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20american%20male%20fitness%20athlete%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3013&orientation=squarish',
    rating: 5,
    date: '2026-03-18',
    content: 'Lost 18kg following the nutrition plans shared here. The accountability partner system is genius — having someone check in on your progress makes all the difference. Life-changing community.',
    helpful: 94,
    verified: true,
  },
  {
    id: 'r14',
    communityId: '11',
    author: 'Hans Weber',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20german%20male%20trader%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3014&orientation=squarish',
    rating: 4,
    date: '2026-02-05',
    content: 'The London session signals are consistently good. The economic calendar breakdowns save me hours of research every week. Would love more coverage of exotic pairs but overall excellent.',
    helpful: 29,
    verified: true,
  },
  {
    id: 'r15',
    communityId: '12',
    author: 'Aisha Johnson',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20african%20american%20female%20developer%20portrait%20headshot%20clean%20white%20background%20minimal%20style&width=48&height=48&seq=3015&orientation=squarish',
    rating: 5,
    date: '2026-03-12',
    content: 'The Flutter channel is incredibly active and helpful. Got my first freelance client through the job board within a week of joining. The monthly app teardowns are educational gold.',
    helpful: 41,
    verified: true,
  },
];
